<template>
    <v-layout>
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md3>
            <v-card>
                <v-toolbar>
                    <v-btn disabled icon>
                        <v-icon>label_important</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        Log In
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" icon>
                        <v-icon>help</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-flex>
                            <img src="../assets/btn_google_signin_dark_normal_web.png" alt="Google Sign In" @click="googleLogin()">
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-spacer></v-spacer>
    </v-layout>
</template>

<script>
    import firebase from 'firebase/app'
    import 'firebase/auth'
    export default {
        beforeRouteEnter (to, from, next) {
            // called before the route that renders this component is confirmed.
            // does NOT have access to `this` component instance,
            // because it has not been created yet when this guard is called!
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    next({
                        path: '/directory_v2',
                    })

                } else {
                    next();
                }
            })
        },
        name: "Login",
        data () {
            return {}
        },
        methods: {
            googleLogin() {
                const provider = new firebase.auth.GoogleAuthProvider();

                firebase.auth().signInWithPopup(provider).then((result) => {
                    this.$store.dispatch('showSuccess', "Welcome, "+ result.user.displayName);
                    let emailTest = result.user.email;
                    let domain = "conflabs.com"
                    if (emailTest.includes(domain)) {
                        this.$store.commit('id',result.user.uid);
                        this.$store.commit('email',result.user.email);
                        this.$store.commit('name',result.user.displayName);
                        this.$store.commit('picture',result.user.photoURL);
                        this.$router.replace('dashboard');
                    } else {
                        this.$store.dispatch('showError', "Failed to sign you in, make sure you are using your company email.");
                        firebase.auth().signOut().then(() => {
                            this.$store.commit('id',null);
                            this.$store.commit('email',null);
                            this.$store.commit('name',null);
                            this.$store.commit('given_name',null);
                            this.$store.commit('family_name',null);
                            this.$store.commit('picture',null);
                            this.$router.replace('login')
                        })
                    }
                }).catch((err) => {
                    alert('oops. ' + err.message)
                })
            }
        }
    }
</script>

<style scoped>

</style>
